<form class="form">
  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.template' | translateHs}}:</div>
    <div class="p-1 w-75">
      <input class="form-control form-select-sm" [ngModelOptions]="{standalone: true}" [(ngModel)]="symbolizer.label"
        (change)="emitChange()" />
    </div>
  </div>

  <hs-symbolizer-color-picker [symbolizer]="symbolizer" attribute="color" opacityAttribute="opacity"
    (changes)="emitChange()" [label]="'STYLER.textColor' | translateHs"></hs-symbolizer-color-picker>

  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.font' | translateHs}}:</div>
    <div class="p-1 w-75">
      <select class="form-control form-select-sm form-select" (change)="emitChange()"
        [ngModelOptions]="{standalone: true}" [(ngModel)]="symbolizer.font" multiple>
        <option *ngFor="let font of fonts" [ngValue]="font">{{font}}</option>
      </select>
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.textSize' | translateHs}}:</div>
    <div class="p-1 w-75">
      <input class="form-control form-select-sm" [ngModelOptions]="{standalone: true}" [(ngModel)]="symbolizer.size"
        (change)="emitChange()" />
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-2">{{'STYLER.justify' | translateHs}}:</div>
    <span class="badge bg-warning mt-2" [title]="'STYLER.warningAttribNotStoredNotVisualized' | translateHs">!</span>
    <div class="p-1 w-75">
      <select class="form-control form-select-sm form-select" [(ngModel)]="symbolizer.justify" (change)="emitChange()"
        [ngModelOptions]="{standalone: true}">
        <option *ngFor="let justify of justifications">{{justify}}</option>
      </select>
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-2">{{'STYLER.transform' | translateHs}}:</div>
    <span class="badge bg-warning mt-2" [title]="'STYLER.warningAttribNotStoredNotVisualized' | translateHs">!</span>
    <div class="p-1 w-75">
      <select class="form-control form-select-sm form-select" [(ngModel)]="symbolizer.transform" (change)="emitChange()"
        [ngModelOptions]="{standalone: true}">
        <option *ngFor="let transform of transforms">{{transform}}</option>
      </select>
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-2">{{'STYLER.fontStyle' | translateHs}}:</div>
    <div class="p-1 w-75">
      <select class="form-control form-select-sm form-select" [(ngModel)]="symbolizer.fontStyle" (change)="emitChange()"
        [ngModelOptions]="{standalone: true}">
        <option *ngFor="let fontStyle of fontStyles">{{fontStyle}}</option>
      </select>
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-2">{{'STYLER.fontWeight' | translateHs}}:</div>
    <div class="p-1 w-75">
      <select class="form-control form-select-sm form-select" [(ngModel)]="symbolizer.fontWeight"
        (change)="emitChange()" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let fontWeight of fontWeights">{{fontWeight}}</option>
      </select>
    </div>
  </div>

  <hs-symbolizer-slider [symbolizer]="symbolizer" attribute="opacity" (changes)="emitChange()" step="0.05" min="0"
    max="1" [label]="'STYLER.opacity' | translateHs"
    [warning]="'STYLER.warningAttribNotStoredVisualized' | translateHs"></hs-symbolizer-slider>

  <hs-symbolizer-color-picker [symbolizer]="symbolizer" attribute="haloColor" (changes)="emitChange()"
    [label]="'STYLER.haloColor' | translateHs"></hs-symbolizer-color-picker>

  <hs-symbolizer-slider [symbolizer]="symbolizer" attribute="haloWidth" (changes)="emitChange()" step="1" min="0"
    max="20" [label]="'STYLER.haloWidth' | translateHs"></hs-symbolizer-slider>

  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.offsetX' | translateHs}}:</div>
    <div class="p-1 w-75">
      <input class="w-100" type="range" step="1" min="-40" max="40" [ngModelOptions]="{standalone: true}"
        [(ngModel)]="symbolizer.offset[0]" *ngIf="symbolizer.offset !== undefined" (change)="emitChange()" />
    </div>
  </div>

  <div class="d-flex flex-row">
    <div class="p-1 w-25">{{'STYLER.offsetY' | translateHs}}:</div>
    <div class="p-1 w-75">
      <input class="w-100" type="range" step="1" min="-40" max="40" [ngModelOptions]="{standalone: true}"
        [(ngModel)]="symbolizer.offset[1]" *ngIf="symbolizer.offset !== undefined" (change)="emitChange()" />
    </div>
  </div>

  <hs-symbolizer-slider [symbolizer]="symbolizer" attribute="rotate" (changes)="emitChange()" step="1" min="0" max="360"
    [label]="'STYLER.rotation' | translateHs"></hs-symbolizer-slider>

  <div class="d-flex flex-row">
    <div class="p-1 w-25 mt-2">{{'STYLER.anchor' | translateHs}}:</div>
    <span class="badge bg-warning mt-2" [title]="'STYLER.warningAttribStoredNotVisualized' | translateHs">!</span>
    <div class="p-1 w-75">
      <select class="form-control form-select-sm form-select" [(ngModel)]="symbolizer.anchor" (change)="emitChange()"
        [ngModelOptions]="{standalone: true}">
        <option *ngFor="let anchor of anchors">{{anchor}}</option>
      </select>
    </div>
  </div>
</form>